import { jsx as _jsx } from "react/jsx-runtime";
import { AdapterBuilder, ComponentSync, TS_Tree } from '@nu-art/thunderstorm-frontend/index';
import './Component_AdvisorWizard_Step_Search.scss';
import { ModuleFE_ScrollBar } from '@app/styles/frontend/modules/ModuleFE_ScrollBar/ModuleFE_ScrollBar';
import { displayMode_Search, stepStatus_NotSubmitted } from '@app/advisor-shared';
import { calculateWizardTree } from './utils/tree-calculation/utils.js';
import { AdvisorWizardTree_NodeRenderer, AdvisorWizardTree_Renderers } from './utils/tree-rendering/utils.js';
export class Component_AdvisorWizard_Step_Search extends ComponentSync {
    initialRender = true;
    //######################### Life Cycle #########################
    deriveStateFromProps(nextProps, state) {
        state.wizardStep = nextProps.wizardStep;
        state.wizardData = nextProps.wizardData;
        state.stepIndex = nextProps.stepIndex;
        state.treeExpansion ??= {};
        state.adapter = this.createAdapter(state);
        return state;
    }
    componentDidMount() {
        //Trigger an update in the scroll ref when this component mounts
        ModuleFE_ScrollBar.updateScrollBar(this.props.scrollRef);
        document.addEventListener('mousedown', this.clearFocusData);
        if (this.initialRender)
            setTimeout(() => this.initialRender = false);
    }
    componentWillUnmount() {
        document.removeEventListener('mousedown', this.clearFocusData);
    }
    forceCreateAdapter() {
        this.setState({ adapter: this.createAdapter() });
    }
    //######################### Logic #########################
    isDisabled(state = this.state) {
        return state.wizardData.item.stepData?.[state.stepIndex].status !== stepStatus_NotSubmitted;
    }
    getSnippetsToRender(state = this.state) {
        const stepData = state.wizardData.item.stepData?.[state.stepIndex];
        return stepData?.snippets[displayMode_Search].map(i => i.snippetId) ?? [];
    }
    clearFocusData = () => {
        if (!this.state.focusedPath)
            return;
        this.setState({ focusedPath: undefined }, () => {
            this.setState({ adapter: this.createAdapter() });
        });
    };
    createAdapter(state = this.state) {
        const editable = state.wizardData.editProp('variableData', {});
        editable.setOnSaveCompleted(async () => {
            this.setState({ adapter: this.createAdapter() });
        });
        const treeData = calculateWizardTree(this.getSnippetsToRender(state), editable, {
            disabled: this.isDisabled(state),
            focusedPath: state.focusedPath,
            onFocus: (path) => {
                this.setState({ focusedPath: path }, () => {
                    this.setState({ adapter: this.createAdapter() });
                });
            },
        });
        const adapter = AdapterBuilder()
            .tree()
            .multiRender(AdvisorWizardTree_Renderers(state.treeExpansion))
            .setNodeRenderer(props => AdvisorWizardTree_NodeRenderer(props, adapter, this.props.scrollRef))
            .setData(treeData)
            .hideRoot()
            .build();
        return adapter;
    }
    checkExpanded = (expanded, path, nodeData) => {
        if (!this.initialRender)
            return this.state.treeExpansion[path];
        switch (nodeData.type) {
            case 'snippet': {
                const expanded = nodeData.length > 0;
                if (!expanded)
                    return false;
                this.state.treeExpansion[path] = true;
                return true;
            }
            case 'variable': {
                if (!nodeData._isParent)
                    return false;
                const isChiefComplaint = this.state.wizardData.item.variableData?.[nodeData.item.id]?.[0]?.isChiefComplaint;
                if (!isChiefComplaint)
                    return false;
                this.state.treeExpansion[path] = true;
                return true;
            }
            default:
                return false;
        }
    };
    //######################### Render #########################
    render() {
        return _jsx("div", { className: 'advisor-step__search', ref: this.props.scrollRef, children: _jsx(TS_Tree, { adapter: this.state.adapter, checkExpanded: this.checkExpanded, onNodeClicked: (path) => {
                    if (this.state.treeExpansion[path])
                        delete this.state.treeExpansion[path];
                    else
                        this.state.treeExpansion[path] = true;
                    this.forceUpdate();
                } }) });
    }
}
//# sourceMappingURL=Component_AdvisorWizard_Step_Search.js.map